import { useEffect, useState } from "react";
import {
  listSnapshots,
  saveSnapshot,
  restoreSnapshot,
  deleteSnapshot,
  type SnapshotInfo,
} from "../lib/contentApi";
import { ActionButton } from "./ActionButton";

// 환경 스냅샷(FR-ADMIN-07): 현재 게시 상태(이미지 매니페스트+전체 존 맵+전자책)를
// 이름으로 저장하고, 언제든 그 이름으로 라이브에 복원(되돌리기).
export function SnapshotPanel() {
  const [snaps, setSnaps] = useState<SnapshotInfo[]>([]);
  const [name, setName] = useState("");
  const [msg, setMsg] = useState<string | null>(null);

  async function refresh() {
    setSnaps(await listSnapshots());
  }
  useEffect(() => {
    void refresh();
  }, []);

  async function onSave() {
    const n = name.trim();
    if (!n) return;
    const out = await saveSnapshot(n); // 실패는 던진다 — ActionButton 이 이유를 보여준다
    setMsg(`✅ '${n}' 으로 저장했어요 (존 배치 ${out.zones}개 포함). 언제든 아래에서 되돌릴 수 있어요.`);
    setName("");
    await refresh();
  }

  // 확인·진행표시·실패표시는 ActionButton 이 한다 — 여기선 일만 하고 실패는 **던진다**.
  // (삼키면 버튼이 성공한 것처럼 보인다)
  async function onRestore(n: string) {
    const a = (await restoreSnapshot(n)).applied;
    setMsg(
      `✅ '${n}' 을 불러왔어요 — 그림${a.manifest ? "✓" : "—"} 전자책${a.book ? "✓" : "—"} 존 배치 ${a.maps.length}개. 아이들이 보는 화면에 바로 반영됐어요.`,
    );
  }

  async function onDelete(n: string) {
    await deleteSnapshot(n);
    await refresh();
    setMsg(`🗑️ 저장된 환경 '${n}' 을 지웠어요.`);
  }

  return (
    /* panel 클래스로 다른 탭과 같은 카드 모양 — 탭마다 생김새가 다르면 어긋나 보인다 */
    <section className="panel snap">
      <header className="panel__head">
        <h2>💾 백업 · 되돌리기</h2>
      </header>
      <p className="hint">
        지금 <b>게시된 환경 전체</b>(그림 목록 · 모든 존 배치 · 전자책)를 이름으로 저장해 두고, 언제든 그 이름으로{" "}
        <b>되돌릴</b> 수 있어요. 되돌리면 아이들이 보는 화면에 바로 반영돼요. <b>AI 키는 저장되지 않아요</b>(보안).
      </p>

      <div className="snap__save">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="환경 이름 (예: 오픈본, 행사용, 테스트)"
          maxLength={60}
          onKeyDown={(e) => e.key === "Enter" && void onSave()}
        />
        <ActionButton
          className="btn btn--primary"
          busyLabel="저장 중…"
          doneLabel="저장됨"
          disabled={!name.trim()}
          onAction={onSave}
        >
          지금 상태 저장
        </ActionButton>
      </div>
      {msg ? <p className="console__publish">{msg}</p> : null}

      <h3 className="snap__title">저장된 환경 ({snaps.length})</h3>
      {snaps.length === 0 ? (
        <p className="zone__tip">아직 저장된 환경이 없어요. 위에서 이름을 지어 저장해 보세요.</p>
      ) : (
        <ul className="snap__list">
          {snaps.map((s) => (
            <li key={s.name} className="snap__item">
              <div>
                <b className="snap__name">{s.name}</b>
                <span className="snap__when">{new Date(s.created_at).toLocaleString("ko-KR")}</span>
              </div>
              <div className="snap__actions">
                {/* ActionButton 이 진행·성공·실패를 스스로 표시한다 — 실패가 조용히 사라지지 않게 */}
                <ActionButton
                  className="btn btn--primary"
                  busyLabel="불러오는 중…"
                  doneLabel="불러옴"
                  confirm={`'${s.name}' 으로 되돌릴까요? 지금 게시된 그림·존 배치·전자책이 이 시점으로 바뀌고, 아이들이 보는 화면에 바로 반영돼요.`}
                  onAction={() => onRestore(s.name)}
                >
                  불러오기
                </ActionButton>
                <ActionButton
                  busyLabel="지우는 중…"
                  doneLabel="지움"
                  confirm={`저장된 환경 '${s.name}' 을 지울까요? (지금 게시된 화면은 그대로예요)`}
                  onAction={() => onDelete(s.name)}
                >
                  삭제
                </ActionButton>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
